export default __webpack_public_path__ + "static/media/sister.4dcfffbb.svg";